import { createApiClient } from "@envirohub/utils";
import { env } from "@/config/env";

export const apiClient = createApiClient(env.VITE_API_BASE_URL);
